export default __webpack_public_path__ + "static/media/Nousis.b35d4abd.png";